import {BASENAME} from "../Constants";
import { resolveMunicipalityId, buildCouncilPath } from './councilParams';

// Called both with (municipalitaId, councilId, bodyType) from detail pages reacting to a
// "not found" loader sentinel, and with just (error) from catch blocks elsewhere - in the
// latter case councilId/bodyType are absent so this always falls through to '/chyba'.
export const redirectErrorPage = (municipalitaId?: unknown, councilId?: unknown, bodyType?: unknown): void => {
    const resolvedMunicipalitaId = resolveMunicipalityId(typeof municipalitaId === 'string' ? municipalitaId : undefined);
    const resolvedCouncilId = typeof councilId === 'string' || typeof councilId === 'number' ? councilId : undefined;
    const resolvedBodyType = typeof bodyType === 'string' ? bodyType : undefined;

    window.location.href = resolvedMunicipalitaId && resolvedCouncilId && resolvedBodyType
        ? (BASENAME ?? '').replace(/\/$/, '') + buildCouncilPath(resolvedMunicipalitaId, resolvedBodyType, resolvedCouncilId, 'chyba')
        : '/chyba';
};

export const getErrorMessage = (error: unknown): string | undefined => {
    const response = (error as { response?: { data?: { error?: string } } })?.response;
    return response?.data?.error;
};
